import styled from '../../../styles/styledComponents/themeComponents';

export const TableSelectStyle = styled.span`
  select {
    width: 100%;
    border: 1px solid rgba(0, 0, 0, 0.1);
    border-radius: 0;
    list-style: none;
    color: rgba(0, 0, 0, 0.65);
    font-size: 16px;
    font-variant: tabular-nums;
    font-weight: 700;
    line-height: 1.5;
    outline: none;

    &:hover {
      border-color: #6200ea !important;
    }

    &:focus {
      border-color: #6200ea !important;
      box-shadow: none;
    }
  }
`;
